<template>
  <a-modal
      :visible="previewVisible"
      :destroyOnClose="true"
      title="文件预览"
      :width="860"
      :footer="null"
      @cancel="previewVisible = false"
  >
    <iframe :src="kkPreviewDocUrl" frameborder="0" width="800" height="600"></iframe>
  </a-modal>
</template>
<script>
import {baseURL, kkURL} from "@/services/HttpService";
import {Base64} from "js-base64";

export default {
  data() {
    return {
      previewVisible: false,
      kkURL,
      kkPreviewDocUrl: "",
      viewUrl: baseURL + "/attachment?fileName=",
    };
  },
  methods: {
    previewFile(doc) {
      console.log('original doc url:', doc.url);
      if(doc.url && !doc.url.endsWith("fileName=undefined") && !doc.url.endsWith("fileName=null")) {
        let docUrl = doc.url;
        if(!docUrl.startsWith("http")) {
          docUrl = this.viewUrl + docUrl;
        }
        let previewUrl = docUrl + '&fullfilename=' + doc.name;
        this.kkPreviewDocUrl = this.kkURL + encodeURIComponent(Base64.encode(previewUrl));
        console.log('kkPreviewUrl:', this.kkPreviewDocUrl);
        this.previewVisible = true;
      } else {
        this.$message.error("未找到文件");
      }
    },
  }
}

</script>